import { render, staticRenderFns } from "./PayrollExport.vue?vue&type=template&id=ccfa6400"
import script from "./PayrollExport.vue?vue&type=script&lang=js"
export * from "./PayrollExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports